import React from 'react';

import { ErrorBoundary } from '@nxte-nl/error-boundary';

import { layoutHooks } from '../../hooks/layoutHooks/layoutHooks';
import { LayoutExtension } from '../../types/ResponsiveState';

export type Props = {
  children: ({
    layoutExtension,
    isDesktop,
  }: {
    isDesktop: boolean;
    isMobileLayout: boolean;
    layoutExtension: LayoutExtension;
  }) => React.ReactNode;
};
export const LayoutExtensionContainer = React.memo((props: Props) => {
  const { children } = props;
  const layoutExtension = layoutHooks.useLayoutExtension();
  const { isDesktop } = layoutHooks.useDesktop();
  const isMobileLayout = layoutHooks.useMobileLayout();

  return <ErrorBoundary>{children({ layoutExtension, isDesktop, isMobileLayout })}</ErrorBoundary>;
});

LayoutExtensionContainer.displayName = 'LayoutExtensionContainer';
